/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_ReadInputs */

const en_gc_resources_guide_read = /** @type {(inputs: Gc_Resources_Guide_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read guide`)
};

const zh_gc_resources_guide_read = /** @type {(inputs: Gc_Resources_Guide_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读指南`)
};

/**
* | output |
* | --- |
* | "Read guide" |
*
* @param {Gc_Resources_Guide_ReadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_read = /** @type {((inputs?: Gc_Resources_Guide_ReadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_ReadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_read(inputs)
	return zh_gc_resources_guide_read(inputs)
});
export { gc_resources_guide_read as "gc.resources.guide.read" }